import { defineStore } from "pinia";
import { computed, Ref, ref } from "vue";
import { User, VignetteModules } from "@/types";

export const useSessionStore = defineStore("session", () => {
  const user: Ref<User | null> = ref(null);
  const hasVignetteAccess: Ref<boolean> = ref(false);

  const almanacExportCount = computed(
    () => user.value?.almanacExportCount ?? 0
  );

  const isLoggedIn = computed(() => user.value != null);
  /**
   * If true, implies isLoggedIn === true
   */
  const isWebUser = computed(() => user.value?.userType === "web_user");

  /**
   * If true, implies isLoggedIn === true
   */
  const isIpUser = computed(() => user.value?.userType === "ip_user");

  /**
   * If true, implies isLoggedIn === true
   */
  const isStaffOrSuperUser = computed(
    () => user.value?.isStaff || user.value?.isSuperUser
  );

  /**
   * If true, implies isLoggedIn === true
   */
  const hasVignetteModuleAccess = (module: VignetteModules) =>
    computed(
      () =>
        hasVignetteAccess.value &&
        user.value?.subscriptionModules.includes(module)
    );

  const hasLapsedSubscription = computed(() => {
    return !!user.value && user.value.accountExpiration < new Date();
  });

  const isHidePayWalledProfilesPreference = computed(() => {
    return !!user.value && user.value.hidePayWalledProfilesPreference;
  });

  const hasCustomLogo = computed(() => {
    return !!user.value && !!user.value?.accountOrganization?.hasCustomLogo;
  });

  function logout() {
    user.value = null;
    hasVignetteAccess.value = false;
    // TODO: This is a hack to force a reload of the page to clear the session cookie
    window.location.href = "";
  }

  return {
    user,
    almanacExportCount,
    hasVignetteAccess,
    isLoggedIn,
    isWebUser,
    isIpUser,
    isStaffOrSuperUser,
    hasVignetteModuleAccess,
    hasLapsedSubscription,
    isHidePayWalledProfilesPreference,
    hasCustomLogo,
    logout,
  };
});
